import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nth',
})
export class NthPipe implements PipeTransform {
    public transform(value: number): string {
        if (!value) {
            return value.toString();
        }

        switch (value) {
            case 1:
                return value + 'st';
            case 2:
                return value + 'nd';
            case 3:
                return value + 'rd';
            default:
                return value + 'th';
        }
    }
}
